import { getSubjects } from "actions/subjects";
import { getTemplates } from "actions/templates";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { styled } from "styled-components";
import Spinner from "components/spinner";
import { useSelector } from "react-redux";
import { IState } from "store/types";
import { getConfig } from "actions/config";
import { ApplicationSettings } from "./admin/ApplicationSettings";
import { isAdminUser } from "lib/utils";

const GreyOuterContainer = styled.div`
  background: var(--neutral-200, #eee);
  height: 100vh;
  padding-top: 50px;
`;

const InnerContainer = styled.div`
  background-color: white;
  margin-right: 219px;
  margin-left: 219px;
`;

const AdminPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 950px;
  align-items: flex-start;
  padding-left: 64px;
  padding-right: 64px;
`;

const PageTitle = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 31px;
  line-height: 31px;
  margin: 0px;
  color: #252525;
  padding: 24px;
  text-align: center;
`;

export const AdminPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConfig());
    dispatch(getSubjects());
    dispatch(getTemplates());
  }, [dispatch]);

  const config = useSelector((state: IState) => state.config);
  const loading = useSelector(
    (state: IState) => state.loadingSubjects || state.loadingTemplates || state.loadingConfig,
  );
  const isAdmin = useCallback(() => {
    if (!loading && config && config.adminIds) {
      return isAdminUser(config.adminIds);
    }
    return false;
  }, [config, loading]);

  if (loading) {
    return <Spinner loading={loading} />;
  } else
    return isAdmin() ? (
      <GreyOuterContainer>
        <InnerContainer>
          <AdminPanel>
            <ApplicationSettings />
          </AdminPanel>
        </InnerContainer>
      </GreyOuterContainer>
    ) : (
      <PageTitle>You are not authorised to view this page.</PageTitle>
    );
};
